import React from 'react';
import { CheckIcon, DownloadIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutUrl, offer, pricingTitle } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="planes" className="w-full bg-night-900 py-16 md:py-24" data-id="element-114" data-mp="2jlyw1qufz5ki">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-115" data-mp="1vubn2nx4yf6i">
        {showUrgency && <CountdownPanel data-id="element-116" data-mp="1rtrnldp3azh7" />}

        <h2 className={`text-center font-display text-[2rem] font-bold leading-tight tracking-tight text-ink md:text-[2.75rem] ${showUrgency ? 'mt-16' : ''}`} data-id="element-117" data-mp="1rujc64k9rwxz">
          {pricingTitle}
        </h2>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-night-700 p-7 shadow-lift ring-1 ring-gold-400/30 md:p-10" data-id="element-118" data-mp="3h6v3vkvpwqf9">
          <p className="text-center font-display text-xl font-bold uppercase leading-snug tracking-[0.04em] text-gold-300 md:text-2xl" data-id="element-119" data-mp="3c7i9mf2ioh2n">
            {offer.name}
          </p>

          <ul className="mx-auto mt-9 grid max-w-xl gap-4 text-left sm:grid-cols-2" data-id="element-120" data-mp="4scp558ik0u5">
            {offer.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-121" data-mp="9sryllpoco6u">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-indigo-500/15 text-indigo-300" data-id="element-122" data-mp="erle1joiup9n">
                  <CheckIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-123" data-mp="3dasc1ge01lru" />
                </span>
                <span className="text-ink" data-id="element-124" data-mp="3i5xwearr6sdt">{item}</span>
              </li>)}
          </ul>

          <div className="mt-10 text-center" data-id="element-125" data-mp="3n524ey2xyk2k">
            <p className="text-sm font-medium uppercase tracking-[0.18em] text-faint" data-id="element-126" data-mp="3ry3kh9evwpnq">
              Valor total: <span className="line-through" data-id="element-127" data-mp="2uj9919jz67pt">{offer.listPrice}</span>
            </p>
            <p className="mt-3 font-display text-xs font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-128" data-mp="2zh1061csppsy">
              Precio hoy
            </p>
            <p className="font-display text-5xl font-bold tracking-tight text-ink md:text-6xl" data-id="element-129" data-mp="2rfa2lgnznzc6">
              {offer.price}
              <span className="ml-2 text-xl font-semibold text-muted" data-id="element-130" data-mp="2mfxih3oi56da">ARS</span>
            </p>
            <p className="mx-auto mt-4 max-w-md text-sm text-muted" data-id="element-131" data-mp="318imn1naup8v">({offer.note})</p>
          </div>

          <div className="mt-9" data-id="element-132" data-mp="2w9xmf281s5kf">
            <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-133" data-mp="28hh54tw4whm6">
              {offer.cta}
            </CtaButton>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-muted" data-id="element-134" data-mp="23l0ffv9adv6z">
          <li className="inline-flex items-center gap-2" data-id="element-135" data-mp="2dh3f8ugo1hqr">
            <LockIcon className="h-4 w-4 text-indigo-400" strokeWidth={1.75} aria-hidden="true" data-id="element-136" data-mp="2dfilv86384uh" />{' '}
            Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-137" data-mp="3owinwvi8ly1p">
            <DownloadIcon className="h-4 w-4 text-indigo-400" strokeWidth={1.75} aria-hidden="true" data-id="element-138" data-mp="3ovz4tbgup3m3" />{' '}
            Descarga inmediata en PDF
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-139" data-mp="57ds74nqx2bp">
            <ShieldCheckIcon className="h-4 w-4 text-gold-400" strokeWidth={1.75} aria-hidden="true" data-id="element-140" data-mp="3ng4t5v6mqcu0" />{' '}
            Garantía total de satisfacción
          </li>
        </ul>
      </div>
    </section>;
}